<template>
  <div ref="wxbtn" class="plv-iar-push-card__wx-btn"></div>
</template>

<script>
import wechatMixin from '@/assets/mixins/wechat';

export default {
  mixins: [wechatMixin],

  props: {
    wxMiniprogramOriginalId: String,
    wxMiniprogramLink: String,
  },

  mounted() {
    this.$nextTick(() => {
      this.createWxBtn();
    });
  },

  methods: {
    createWxBtn() {
      const width = this.$refs.wxbtn.clientWidth;
      const height = this.$refs.wxbtn.clientHeight;

      this.createWxMiniProgramButton({
        wrap: this.$refs.wxbtn,
        wxMiniprogramOriginalId: this.wxMiniprogramOriginalId,
        wxMiniprogramLink: this.wxMiniprogramLink,
        classKey: 'pushcard',
        width,
        height,
        lanuchCallback: () => {
          this.$emit('close');
        }
      });
    }
  },
};
</script>

<style lang="scss">
.plv-iar-push-card__wx-btn {
  width: 100%;
  height: 100%;
}
</style>
